module.exports = __webpack_public_path__ + "/login_ui/img/iq-0a77c7fd85fdac1c80cbfec10de3be98.svg";